(function () {
  if (customElements.get('tro-training-program-recommender')) return;

  const stepKeys = ['path', 'situation', 'priority', 'result'];
  const stepLabels = {
    path: 'Tavoite',
    situation: 'Tilanne',
    priority: 'Tärkeintä',
    result: 'Tulos',
  };

  const questionConfig = {
    path: {
      question: 'Mitä haluat kehittää juuri nyt?',
      options: [
        {
          key: 'path.gym_basics',
          value: 'gym_basics',
          label: 'Haluan aloittaa tai jatkaa salitreeniä perusteista',
          icon: 'barbell',
        },
        {
          key: 'path.booty_focus',
          value: 'booty_focus',
          label: 'Haluan erityisesti pakara-/jalkapainotteisen saliohjelman',
          icon: 'spark',
        },
        {
          key: 'path.home_training',
          value: 'home_training',
          label: 'Haluan treenata kotona',
          icon: 'home',
        },
        {
          key: 'path.running_focus',
          value: 'running_focus',
          label: 'Haluan parantaa juoksukuntoa',
          icon: 'run',
        },
        {
          key: 'path.academy_focus',
          value: 'academy_focus',
          label: 'Haluan toiminnallisen ohjelman poliisi-/pelastusalan tyyppiseen treeniin',
          icon: 'shield',
        },
        {
          key: 'path.fightclub_focus',
          value: 'fightclub_focus',
          label: 'Haluan kamppailijan oheisharjoittelua',
          icon: 'bolt',
        },
      ],
    },
    situation: {
      gym_basics: {
        question: 'Mikä kuvaa tilannettasi parhaiten?',
        options: [
          {
            key: 'gym_basics.situation.start_from_zero',
            value: 'start_from_zero',
            label: 'Aloitan käytännössä alusta',
            icon: 'level',
          },
          {
            key: 'gym_basics.situation.return_after_break',
            value: 'return_after_break',
            label: 'Palaan takaisin treenin pariin',
            icon: 'refresh',
          },
          {
            key: 'gym_basics.situation.want_clear_structure',
            value: 'want_clear_structure',
            label: 'Haluan selkeän rungon salitreenin aloittamiseen',
            icon: 'structure',
          },
        ],
      },
      booty_focus: {
        question: 'Missä vaiheessa olet tällä polulla?',
        options: [
          {
            key: 'booty_focus.situation.first_time',
            value: 'first_time',
            label: 'En ole tehnyt BOOTY GAINZ -ohjelmaa aiemmin',
            icon: 'spark',
          },
          {
            key: 'booty_focus.situation.done_booty_1',
            value: 'done_booty_1',
            label: 'Olen tehnyt BOOTY GAINZ -ohjelman aiemmin',
            icon: 'check',
          },
          {
            key: 'booty_focus.situation.done_booty_1_and_2',
            value: 'done_booty_1_and_2',
            label: 'Olen tehnyt BOOTY GAINZ -ohjelman ja BOOTY GAINZ 2.0:n aiemmin',
            icon: 'trophy',
          },
        ],
      },
      home_training: {
        question: 'Miksi kotitreeni kiinnostaa juuri nyt eniten?',
        options: [
          {
            key: 'home_training.situation.easy_at_home',
            value: 'easy_at_home',
            label: 'Haluan treenata helposti kotona',
            icon: 'home',
          },
          {
            key: 'home_training.situation.save_time',
            value: 'save_time',
            label: 'Haluan säästää aikaa',
            icon: 'timer',
          },
          {
            key: 'home_training.situation.lower_threshold',
            value: 'lower_threshold',
            label: 'Haluan madaltaa treenin aloittamisen kynnystä',
            icon: 'level',
          },
        ],
      },
      running_focus: {
        question: 'Mikä kuvaa tilannettasi tai tavoitettasi parhaiten?',
        options: [
          {
            key: 'running_focus.situation.cooper_goal',
            value: 'cooper_goal',
            label: 'Haluan nimenomaan parantaa Cooper-tulostani',
            icon: 'target',
          },
          {
            key: 'running_focus.situation.under_10',
            value: 'under_10',
            label: 'En juokse juuri lainkaan tai alle 10 minuuttia putkeen',
            icon: 'timer',
          },
          {
            key: 'running_focus.situation.run_10_15',
            value: 'run_10_15',
            label: 'Juoksen noin 10-15 minuuttia putkeen',
            icon: 'timer',
          },
          {
            key: 'running_focus.situation.run_30_35',
            value: 'run_30_35',
            label: 'Juoksen noin 30-35 minuuttia tai noin 5-8 km',
            icon: 'run',
          },
        ],
      },
      academy_focus: {
        question: 'Kumpi kuvaa sinua paremmin?',
        options: [
          { key: 'academy_focus.situation.male', value: 'male', label: 'Mies', icon: 'person' },
          { key: 'academy_focus.situation.female', value: 'female', label: 'Nainen', icon: 'person' },
        ],
      },
      fightclub_focus: {
        question: 'Mikä kiinnostaa sinua tässä eniten?',
        options: [
          {
            key: 'fightclub_focus.situation.explosiveness',
            value: 'explosiveness',
            label: 'Räjähtävyys',
            icon: 'bolt',
          },
          {
            key: 'fightclub_focus.situation.conditioning',
            value: 'conditioning',
            label: 'Peruskunto',
            icon: 'run',
          },
          {
            key: 'fightclub_focus.situation.versatile_support',
            value: 'versatile_support',
            label: 'Monipuolinen oheistreeni',
            icon: 'structure',
          },
        ],
      },
    },
    priority: {
      gym_basics: {
        question: 'Mikä sinulle on tässä tärkeintä?',
        options: [
          { key: 'gym_basics.priority.easy_start', value: 'easy_start', label: 'Helppo aloitus', icon: 'spark' },
          {
            key: 'gym_basics.priority.clear_structure',
            value: 'clear_structure',
            label: 'Selkeä rakenne',
            icon: 'structure',
          },
          { key: 'gym_basics.priority.routine', value: 'routine', label: 'Hyvä treenirutiini', icon: 'refresh' },
        ],
      },
      booty_focus: {
        question: 'Mitä haluat painottaa eniten?',
        options: [
          { key: 'booty_focus.priority.glutes', value: 'glutes', label: 'Pakaroita', icon: 'spark' },
          { key: 'booty_focus.priority.legs', value: 'legs', label: 'Jalkoja', icon: 'barbell' },
          {
            key: 'booty_focus.priority.balanced_lower',
            value: 'balanced_lower',
            label: 'Tasaisesti molempia',
            icon: 'structure',
          },
        ],
      },
      home_training: {
        question: 'Mikä kuvaa sinua parhaiten?',
        options: [
          {
            key: 'home_training.priority.start_fast',
            value: 'start_fast',
            label: 'Haluan päästä vauhtiin nopeasti',
            icon: 'bolt',
          },
          {
            key: 'home_training.priority.want_home_structure',
            value: 'want_home_structure',
            label: 'Haluan selkeän kotitreenirungon',
            icon: 'structure',
          },
          {
            key: 'home_training.priority.keep_it_simple',
            value: 'keep_it_simple',
            label: 'Haluan pitää treenaamisen mahdollisimman helppona',
            icon: 'check',
          },
        ],
      },
      running_focus: {
        question: 'Mikä motivoi sinua eniten juoksussa?',
        options: [
          {
            key: 'running_focus.priority.better_base_fitness',
            value: 'better_base_fitness',
            label: 'Parempi peruskunto',
            icon: 'run',
          },
          {
            key: 'running_focus.priority.easier_long_runs',
            value: 'easier_long_runs',
            label: 'Pidemmät lenkit helpommin',
            icon: 'timer',
          },
          {
            key: 'running_focus.priority.improve_test_result',
            value: 'improve_test_result',
            label: 'Testituloksen parantaminen',
            icon: 'target',
          },
        ],
      },
      academy_focus: {
        question: 'Mikä on sinulle tässä tärkeintä?',
        options: [
          {
            key: 'academy_focus.priority.entrance_exam',
            value: 'entrance_exam',
            label: 'Valmistautua pääsykokeisiin',
            icon: 'target',
          },
          {
            key: 'academy_focus.priority.versatile_performance',
            value: 'versatile_performance',
            label: 'Kehittää monipuolista suorituskykyä',
            icon: 'shield',
          },
          {
            key: 'academy_focus.priority.more_functional_training',
            value: 'more_functional_training',
            label: 'Treenata tavoitteellisesti toiminnallisemmin',
            icon: 'bolt',
          },
        ],
      },
      fightclub_focus: {
        question: 'Mikä kuvaa sinua parhaiten?',
        options: [
          {
            key: 'fightclub_focus.priority.martial_arts',
            value: 'martial_arts',
            label: 'Harrastan kamppailulajia',
            icon: 'bolt',
          },
          {
            key: 'fightclub_focus.priority.want_athletic_style',
            value: 'want_athletic_style',
            label: 'Haluan urheilullisemman treenityylin',
            icon: 'run',
          },
          {
            key: 'fightclub_focus.priority.not_basic_gym',
            value: 'not_basic_gym',
            label: 'Haluan jotain muuta kuin perus punttiohjelman',
            icon: 'barbell',
          },
        ],
      },
    },
  };

  const resultRules = {
    gym_basics: 'rookie_program',
    home_training: 'kotitreeni',
    fightclub_focus: 'fightclub',
    booty_focus: {
      first_time: 'booty_gainz_1',
      done_booty_1: 'booty_gainz_2',
      done_booty_1_and_2: 'booty_gainz_3',
    },
    running_focus: {
      cooper_goal: 'cooper',
      under_10: 'juoksu_1',
      run_10_15: 'juoksu_2',
      run_30_35: 'juoksu_3',
    },
    academy_focus: {
      male: 'academy_men',
      female: 'academy_women',
    },
  };

  const optionIconMap = {
    gym_basics: {
      iconUrl: 'https://cdn.shopify.com/s/files/1/0660/7057/7418/files/crossfit.png?v=1779457648',
    },
    booty_focus: {
      iconUrl: 'https://cdn.shopify.com/s/files/1/0660/7057/7418/files/bottom_1.png?v=1779459328',
    },
    home_training: {
      iconUrl: 'https://cdn.shopify.com/s/files/1/0660/7057/7418/files/home.png?v=1779458862',
    },
    running_focus: {
      iconUrl: 'https://cdn.shopify.com/s/files/1/0660/7057/7418/files/runer-silhouette-running-fast_1.png?v=1779457648',
    },
    academy_focus: {
      iconUrl: 'https://cdn.shopify.com/s/files/1/0660/7057/7418/files/security-agent.png?v=1779457649',
    },
    fightclub_focus: {
      iconUrl: 'https://cdn.shopify.com/s/files/1/0660/7057/7418/files/martial-art.png?v=1779457649',
    },
    start_from_zero: {
      iconUrl: 'https://cdn.shopify.com/s/files/1/0660/7057/7418/files/finish-flag.png?v=1779459840',
    },
    return_after_break: {
      iconUrl: 'https://cdn.shopify.com/s/files/1/0660/7057/7418/files/undo.png?v=1779459975',
    },
    want_clear_structure: {
      iconUrl: 'https://cdn.shopify.com/s/files/1/0660/7057/7418/files/star_3.png?v=1779457756',
    },
    easy_start: {
      iconUrl: 'https://cdn.shopify.com/s/files/1/0660/7057/7418/files/finish-flag.png?v=1779459840',
    },
    clear_structure: {
      iconUrl: 'https://cdn.shopify.com/s/files/1/0660/7057/7418/files/hierarchical-structure_1.png?v=1779459840',
    },
    routine: {
      iconUrl: 'https://cdn.shopify.com/s/files/1/0660/7057/7418/files/routine.png?v=1779459890',
    },
    first_time: {
      iconUrl: 'https://cdn.shopify.com/s/files/1/0660/7057/7418/files/zero.png?v=1779459613',
    },
    done_booty_1: {
      iconUrl: 'https://cdn.shopify.com/s/files/1/0660/7057/7418/files/one.png?v=1779459613',
    },
    done_booty_1_and_2: {
      iconUrl: 'https://cdn.shopify.com/s/files/1/0660/7057/7418/files/2.png?v=1779459613',
    },
    glutes: {
      iconUrl: 'https://cdn.shopify.com/s/files/1/0660/7057/7418/files/butt.png?v=1779459154',
    },
    legs: {
      iconUrl: 'https://cdn.shopify.com/s/files/1/0660/7057/7418/files/leg_3.png?v=1779459541',
    },
    balanced_lower: {
      iconUrl: 'https://cdn.shopify.com/s/files/1/0660/7057/7418/files/balance.png?v=1779459400',
    },
    easy_at_home: {
      iconUrl: 'https://cdn.shopify.com/s/files/1/0660/7057/7418/files/home.png?v=1779458862',
    },
    save_time: {
      iconUrl: 'https://cdn.shopify.com/s/files/1/0660/7057/7418/files/clock.png?v=1779459840',
    },
    lower_threshold: {
      iconUrl: 'https://cdn.shopify.com/s/files/1/0660/7057/7418/files/social.png?v=1779460485',
    },
    start_fast: {
      iconUrl: 'https://cdn.shopify.com/s/files/1/0660/7057/7418/files/shuttle.png?v=1779462775',
    },
    want_home_structure: {
      iconUrl: 'https://cdn.shopify.com/s/files/1/0660/7057/7418/files/routine.png?v=1779459890',
    },
    keep_it_simple: {
      iconUrl: 'https://cdn.shopify.com/s/files/1/0660/7057/7418/files/star_3.png?v=1779457756',
    },
    cooper_goal: {
      iconUrl: 'https://cdn.shopify.com/s/files/1/0660/7057/7418/files/finish-flag.png?v=1779459840',
    },
    under_10: {
      starsPattern: ['filled', 'empty', 'empty'],
    },
    run_10_15: {
      starsPattern: ['filled', 'filled', 'empty'],
    },
    run_30_35: {
      starsPattern: ['filled', 'filled', 'filled'],
    },
    better_base_fitness: {
      iconUrl: 'https://cdn.shopify.com/s/files/1/0660/7057/7418/files/marathon.png?v=1779460224',
    },
    easier_long_runs: {
      iconUrl: 'https://cdn.shopify.com/s/files/1/0660/7057/7418/files/finish-line.png?v=1779460225',
    },
    improve_test_result: {
      iconUrl: 'https://cdn.shopify.com/s/files/1/0660/7057/7418/files/finish-flag.png?v=1779459840',
    },
    male: {
      iconUrl: 'https://cdn.shopify.com/s/files/1/0660/7057/7418/files/man_2.png?v=1779460297',
    },
    female: {
      iconUrl: 'https://cdn.shopify.com/s/files/1/0660/7057/7418/files/woman_1.png?v=1779460298',
    },
    entrance_exam: {
      iconUrl: 'https://cdn.shopify.com/s/files/1/0660/7057/7418/files/routine.png?v=1779459890',
    },
    versatile_performance: {
      iconUrl: 'https://cdn.shopify.com/s/files/1/0660/7057/7418/files/expand.png?v=1779460387',
    },
    more_functional_training: {
      iconUrl: 'https://cdn.shopify.com/s/files/1/0660/7057/7418/files/finish-flag.png?v=1779459840',
    },
    explosiveness: {
      iconUrl: 'https://cdn.shopify.com/s/files/1/0660/7057/7418/files/explode.png?v=1779460539',
    },
    conditioning: {
      iconUrl: 'https://cdn.shopify.com/s/files/1/0660/7057/7418/files/social.png?v=1779460485',
    },
    versatile_support: {
      iconUrl: 'https://cdn.shopify.com/s/files/1/0660/7057/7418/files/expand.png?v=1779460387',
    },
    martial_arts: {
      iconUrl: 'https://cdn.shopify.com/s/files/1/0660/7057/7418/files/martial-art.png?v=1779457649',
    },
    want_athletic_style: {
      iconUrl: 'https://cdn.shopify.com/s/files/1/0660/7057/7418/files/runer-silhouette-running-fast_1.png?v=1779457648',
    },
    not_basic_gym: {
      iconUrl: 'https://cdn.shopify.com/s/files/1/0660/7057/7418/files/star_4.png?v=1779457756',
    },
  };

  const personalizationRules = {
    gym_basics: ({ situation, priority }) => {
      const badges = {
        easy_start: 'Matalan kynnyksen aloitus',
        clear_structure: 'Selkeä eteneminen',
        routine: 'Rutiinin rakentajalle',
      };
      const ctas = {
        easy_start: 'Aloita tästä',
        clear_structure: 'Tutustu ohjelmaan',
        routine: 'Rakenna rutiini',
      };
      const situationCopy = {
        start_from_zero: 'Koska aloitat käytännössä alusta, suositus painottaa rauhallista starttia ja selkeitä perusliikkeitä.',
        return_after_break: 'Koska palaat treenin pariin tauon jälkeen, suositus antaa turvallisen rungon rytmin löytämiseen.',
        want_clear_structure: 'Koska kaipaat selkeää runkoa, suositus auttaa rakentamaan salitreenin peruspalikat järjestyksessä.',
      };
      const priorityCopy = {
        easy_start: 'Saat matalan kynnyksen tavan päästä liikkeelle ilman turhaa säätöä.',
        clear_structure: 'Ohjelman selkeä rakenne auttaa etenemään viikko viikolta.',
        routine: 'Ohjelma sopii hyvän treenirutiinin rakentamiseen alusta asti.',
      };
      const situationNotes = {
        start_from_zero: 'Saat rauhallisen ja selkeän alun, jossa ensimmäinen tavoite on päästä kiinni tekemiseen ilman, että salitreeni tuntuu liian isolta palalta.',
        return_after_break: 'Saat hyvän rungon paluuseen, kun haluat löytää rytmin uudelleen ja rakentaa tekemistä järkevästi tauon jälkeen.',
        want_clear_structure: 'Saat valmiin suunnan salitreeniin: mitä tehdään, missä järjestyksessä ja miten treeneissä pysyy punainen lanka mukana.',
      };
      const priorityNotes = {
        easy_start: 'Tämä on hyvä valinta, kun tärkeintä on aloittaa kevyesti mutta silti määrätietoisesti.',
        clear_structure: 'Tämä sopii sinulle, kun haluat että ohjelma tekee etenemisestä helppoa seurata.',
        routine: 'Tämä auttaa rakentamaan treenistä toistuvan tavan, ei vain yksittäistä innostuspiikkiä.',
      };
      return {
        resultBadge: badges[priority] || badges.easy_start,
        resultReason: `${situationCopy[situation] || situationCopy.want_clear_structure} ${priorityCopy[priority] || priorityCopy.clear_structure}`,
        resultCtaLabel: ctas[priority] || 'Tutustu ohjelmaan',
        optionalResultNote: `${situationNotes[situation] || situationNotes.want_clear_structure} ${
          priorityNotes[priority] || priorityNotes.clear_structure
        }`,
      };
    },
    booty_focus: ({ situation, priority }) => {
      const badges = {
        glutes: 'Pakarafokus',
        legs: 'Jalkafokus',
        balanced_lower: 'Tasapainoinen alakroppa',
      };
      const ctas = {
        glutes: 'Tutustu BOOTY-ohjelmaan',
        legs: 'Katso ohjelma',
        balanced_lower: 'Avaa suositus',
      };
      const situationCopy = {
        first_time: 'Tämä on luonteva aloitus pakara- ja jalkapainotteiseen harjoitteluun.',
        done_booty_1: 'Koska olet jo tehnyt ensimmäisen BOOTY GAINZ -ohjelman, seuraava vaihe vie tekemistä eteenpäin.',
        done_booty_1_and_2: 'Koska aiemmat vaiheet ovat jo tuttuja, tämä jatkaa alakropan kehittämistä seuraavalle tasolle.',
      };
      const priorityCopy = {
        glutes: 'Suositus painottaa erityisesti pakaroiden kehittämistä.',
        legs: 'Suositus sopii, kun haluat antaa jaloille vahvemman painotuksen.',
        balanced_lower: 'Suositus tukee koko alakropan tasapainoista kehitystä.',
      };
      const situationNotes = {
        first_time: 'Valitsin sinulle aloituskohdan, jossa pääset rakentamaan pakara- ja jalkapainotteista treeniä selkeällä rungolla heti ensimmäisestä viikosta.',
        done_booty_1: 'Koska ensimmäinen vaihe on jo tuttu, suositus vie tekemistä seuraavaan tasoon ilman että aloitat taas alusta.',
        done_booty_1_and_2: 'Koska aiemmat vaiheet ovat jo takana, suositus antaa jatkoon lisää haastetta ja uuden syyn tehdä treenit kunnolla.',
      };
      const notes = {
        glutes: 'Pakarapainotus antaa treeneille selkeän fokuksen: enemmän määrätietoista tekemistä sinne, missä haluat nähdä kehitystä.',
        legs: 'Jalkapainotus sopii hyvin, kun haluat alakroppaan lisää voimaa, muotoa ja treeneihin kunnolla tekemisen tuntua.',
        balanced_lower: 'Tasapainoinen painotus pitää kokonaisuuden järkevänä, kun haluat kehittää pakaroita ja jalkoja ilman liian yksipuolista tekemistä.',
      };
      return {
        resultBadge: badges[priority] || badges.balanced_lower,
        resultReason: `${situationCopy[situation] || situationCopy.first_time} ${priorityCopy[priority] || priorityCopy.balanced_lower}`,
        resultCtaLabel: ctas[priority] || 'Avaa suositus',
        optionalResultNote: `${situationNotes[situation] || situationNotes.first_time} ${notes[priority] || notes.balanced_lower}`,
      };
    },
    home_training: ({ situation, priority }) => {
      const badges = {
        easy_at_home: 'Helppo tehdä kotona',
        save_time: 'Ajansäästäjälle',
        lower_threshold: 'Matalan kynnyksen valinta',
      };
      const ctas = {
        start_fast: 'Aloita kotona',
        want_home_structure: 'Tutustu kotiohjelmaan',
        keep_it_simple: 'Katso helppo aloitus',
      };
      const priorityCopy = {
        start_fast: 'Suositus auttaa pääsemään nopeasti vauhtiin kotona.',
        want_home_structure: 'Suositus antaa selkeän rungon kotitreeneille.',
        keep_it_simple: 'Suositus pitää treenaamisen mahdollisimman helposti lähestyttävänä.',
      };
      const situationNotes = {
        easy_at_home: 'Tämä sopii arkeen, jossa treenin pitää onnistua kotona ilman ylimääräistä lähtemistä tai monimutkaista valmistelua.',
        save_time: 'Tämä on hyvä valinta, kun haluat säästää aikaa mutta silti tehdä treenistä oikeasti suunnitelmallista.',
        lower_threshold: 'Tämä madaltaa aloittamisen kynnystä: saat selkeän tavan tehdä treeni, vaikka päivä ei olisi täydellinen.',
      };
      const priorityNotes = {
        start_fast: 'Pääset nopeasti liikkeelle ja saat ensimmäiset treenit rullaamaan ilman pitkää pohdintaa.',
        want_home_structure: 'Selkeä kotitreenirunko auttaa pitämään tekemisen kasassa viikosta toiseen.',
        keep_it_simple: 'Treenin ei tarvitse olla monimutkaista ollakseen tehokasta, ja juuri siihen tämä suositus osuu.',
      };
      return {
        resultBadge: badges[situation] || badges.easy_at_home,
        resultReason: `${priorityCopy[priority] || priorityCopy.want_home_structure} Se sopii hyvin, kun haluat tehokkaan vaihtoehdon ilman kuntosalille lähtemistä.`,
        resultCtaLabel: ctas[priority] || 'Tutustu kotiohjelmaan',
        optionalResultNote: `${situationNotes[situation] || situationNotes.easy_at_home} ${
          priorityNotes[priority] || priorityNotes.want_home_structure
        }`,
      };
    },
    running_focus: ({ situation, priority, productKey }) => {
      const badges = {
        better_base_fitness: 'Parempaan peruskuntoon',
        easier_long_runs: 'Lenkit rullaamaan',
        improve_test_result: 'Tavoitteelliseen juoksuun',
      };
      const notes = {
        better_base_fitness: 'Saat ohjelman, joka rakentaa juoksuun pohjaa rauhallisesti ja auttaa tekemään lenkeistä vähitellen kevyemmän tuntuisia.',
        easier_long_runs: 'Saat selkeän suunnan siihen, että pidemmät lenkit alkavat tuntua hallittavammilta eikä eteneminen jää pelkän fiiliksen varaan.',
        improve_test_result: 'Saat tavoitteellisen rungon, jossa tekeminen tähtää mitattavaan kehitykseen ja parempaan testisuoritukseen.',
      };
      const productNotes = {
        cooper: 'Cooper-tavoite tekee valinnasta selkeän: tarvitset ohjelman, joka keskittyy juuri testituloksen parantamiseen.',
        juoksu_1: 'Koska juoksu on vielä alussa, tärkeintä on rakentaa onnistumisia ja peruskuntoa askel kerrallaan.',
        juoksu_2: 'Koska pystyt jo juoksemaan jonkin verran, seuraava hyvä askel on kasvattaa kestävyyttä hallitusti.',
        juoksu_3: 'Koska pohjaa on jo olemassa, suositus auttaa nostamaan tasoa ja tekemään juoksusta vahvempaa.',
      };
      let reason = 'Suositus valitaan nykyisen juoksutilanteesi tai tärkeimmän tavoitteesi perusteella.';
      if (productKey === 'cooper' && priority === 'improve_test_result') {
        reason = 'Koska tavoitteesi on testituloksen parantaminen, Cooper-ohjelma osuu parhaiten juuri tähän tarpeeseen.';
      } else if (productKey === 'juoksu_1' && priority === 'better_base_fitness') {
        reason = 'Koska juoksu on vielä alussa ja haet parempaa peruskuntoa, tämä ohjelma rakentaa pohjaa vaiheittain.';
      } else if (productKey === 'juoksu_3' && priority === 'easier_long_runs') {
        reason = 'Koska olet jo pidemmällä ja haluat pidemmät lenkit hallintaan, tämä ohjelma tukee tason nostamista.';
      } else if (productKey === 'cooper') {
        reason = 'Cooper-tavoite ohjaa suosituksen ohjelmaan, joka keskittyy nimenomaan testituloksen parantamiseen.';
      } else if (productKey === 'juoksu_1') {
        reason = 'Tämä ohjelma sopii hyvin, kun haluat rakentaa juoksukuntoa alusta selkeällä etenemisellä.';
      } else if (productKey === 'juoksu_2') {
        reason = 'Tämä ohjelma sopii, kun pystyt jo juoksemaan jonkin verran ja haluat kasvattaa kestävyyttä.';
      } else if (productKey === 'juoksu_3') {
        reason = 'Tämä ohjelma sopii, kun juoksupohjaa on jo ja haluat nostaa tasoa edelleen.';
      }
      return {
        resultBadge: badges[priority] || badges.better_base_fitness,
        resultReason: reason,
        resultCtaLabel: situation === 'cooper_goal' ? 'Tutustu Cooper-ohjelmaan' : 'Tutustu juoksuohjelmaan',
        optionalResultNote: `${productNotes[productKey] || productNotes.juoksu_1} ${
          notes[priority] || 'Saat juoksuun selkeän suunnan ja onnistumisia matkan varrelle.'
        }`,
      };
    },
    academy_focus: ({ priority }) => {
      const badges = {
        entrance_exam: 'Pääsykoetavoitteeseen',
        versatile_performance: 'Monipuoliseen suorituskykyyn',
        more_functional_training: 'Toiminnallisempaan treeniin',
      };
      const reasons = {
        entrance_exam: 'Pääsykoetavoite painottaa valmistautumista, monipuolisuutta ja käytännössä hyödyllistä suorituskykyä.',
        versatile_performance: 'Monipuolinen suorituskyky tarvitsee ohjelman, jossa voima, kunto ja tekemisen laatu kulkevat yhdessä.',
        more_functional_training: 'Toiminnallisempi harjoittelu tarvitsee selkeän rungon, jotta treeni pysyy tavoitteellisena.',
      };
      const notes = {
        entrance_exam: 'Saat treeniin pääsykoetyyppistä selkeyttä: voimaa, kestävyyttä ja tekemistä, joka tuntuu käytännössä hyödylliseltä.',
        versatile_performance: 'Saat ohjelman, joka ei nojaa vain yhteen ominaisuuteen, vaan rakentaa suorituskykyä monipuolisesti.',
        more_functional_training: 'Saat tavoitteellisen tavan treenata toiminnallisemmin, kun haluat että harjoittelu tuntuu urheilulliselta ja hyödylliseltä.',
      };
      const ctas = {
        entrance_exam: 'Katso suositeltu Academy',
        versatile_performance: 'Tutustu Academy-ohjelmaan',
        more_functional_training: 'Avaa ohjelma',
      };
      return {
        resultBadge: badges[priority] || badges.versatile_performance,
        resultReason: reasons[priority] || reasons.versatile_performance,
        resultCtaLabel: ctas[priority] || 'Tutustu Academy-ohjelmaan',
        optionalResultNote: notes[priority] || notes.versatile_performance,
      };
    },
    fightclub_focus: ({ situation, priority }) => {
      const badges = {
        explosiveness: 'Räjähtävyyttä',
        conditioning: 'Kuntoa ja kapasiteettia',
        versatile_support: 'Monipuolista oheistreeniä',
      };
      const reasons = {
        martial_arts: 'Suositus tukee kamppailulajin oheisharjoittelua voiman, kapasiteetin ja urheilullisuuden kautta.',
        want_athletic_style: 'Suositus sopii, kun haluat urheilullisemman treenityylin perinteisen saliohjelman sijaan.',
        not_basic_gym: 'Suositus on hyvä vaihtoehto, kun etsit jotain muuta kuin perus punttiohjelmaa.',
      };
      const situationNotes = {
        explosiveness: 'Räjähtävyyspainotus antaa treeniin terävyyttä ja urheilullista tunnetta, joka sopii hyvin kamppailun tueksi.',
        conditioning: 'Peruskuntopainotus auttaa rakentamaan kapasiteettia, jotta tekeminen ei jää vain yksittäisiin koviin suorituksiin.',
        versatile_support: 'Monipuolinen oheistreeni pitää kokonaisuuden kiinnostavana ja tukee useampaa fyysistä ominaisuutta samaan aikaan.',
      };
      const priorityNotes = {
        martial_arts: 'Hyvä valinta, kun haluat että salin ulkopuolinen tekeminen palvelee lajitreeniä paremmin.',
        want_athletic_style: 'Hyvä valinta, kun kaipaat treeniin urheilullisempaa rytmiä ja enemmän suorituskykyä.',
        not_basic_gym: 'Hyvä valinta, kun perinteinen punttiohjelma ei tunnu omalta ja haluat tekemiseen enemmän liikettä.',
      };
      const ctas = {
        martial_arts: 'Tutustu FIGHTCLUBiin',
        want_athletic_style: 'Katso ohjelma',
        not_basic_gym: 'Avaa urheilullinen ohjelma',
      };
      return {
        resultBadge: badges[situation] || badges.versatile_support,
        resultReason: reasons[priority] || reasons.want_athletic_style,
        resultCtaLabel: ctas[priority] || 'Katso ohjelma',
        optionalResultNote: `${situationNotes[situation] || situationNotes.versatile_support} ${
          priorityNotes[priority] || priorityNotes.want_athletic_style
        }`,
      };
    },
  };

  const defaultPersonalization = {
    resultBadge: 'Suositus',
    resultReason: 'Tämä ohjelma sopii parhaiten antamiesi vastausten perusteella.',
    resultCtaLabel: 'Tutustu ohjelmaan',
    optionalResultNote: 'Saat suosituksen, joka vie tekemistäsi selkeään suuntaan ja tekee ohjelman valinnasta helpompaa.',
  };

  const defaultIcons = {
    barbell:
      '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M4 9v6M8 7v10M16 7v10M20 9v6M8 12h8" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>',
    spark:
      '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8L12 3zM18 15l.8 2.2L21 18l-2.2.8L18 21l-.8-2.2L15 18l2.2-.8L18 15z" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/></svg>',
    home:
      '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M4 11.2L12 4l8 7.2M6.5 10v9h11v-9M10 19v-5h4v5" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    run:
      '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M15.5 5.2a1.9 1.9 0 1 1-3.8 0 1.9 1.9 0 0 1 3.8 0zM11 9l3.2 1.8 2.8-1.2M10.2 9.4l-1.7 4.1 3.1 1.8-2 4.7M13.6 15.2l2 4.8M8.4 13.5L5 13" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    target:
      '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="7.5" fill="none" stroke="currentColor" stroke-width="1.6"/><circle cx="12" cy="12" r="3.5" fill="none" stroke="currentColor" stroke-width="1.6"/><path d="M12 2.5v3M12 18.5v3M2.5 12h3M18.5 12h3" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>',
    shield:
      '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 3.5l7 2.4v5.4c0 4.4-2.8 7.7-7 9.2-4.2-1.5-7-4.8-7-9.2V5.9l7-2.4z" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><path d="M9 12l2 2 4-4" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    bolt:
      '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M13 2.8L5.8 13h5.1L10 21.2 18.2 10h-5.4L13 2.8z" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>',
    check:
      '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M5 12.5l4.2 4.2L19 7" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    level:
      '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M5 19V9M12 19V5M19 19v-7" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/><path d="M3.5 19h17" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>',
    timer:
      '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M9 3h6M12 13V8M12 21a7 7 0 1 0 0-14 7 7 0 0 0 0 14z" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>',
    person:
      '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><circle cx="12" cy="7.5" r="3" fill="none" stroke="currentColor" stroke-width="1.6"/><path d="M5.5 20c.8-4.2 3.1-6.2 6.5-6.2s5.7 2 6.5 6.2" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>',
    trophy:
      '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M8 4h8v4.5a4 4 0 0 1-8 0V4zM10 17h4M9 20h6M8 6H5.5c0 2.4 1.1 4 3.1 4.5M16 6h2.5c0 2.4-1.1 4-3.1 4.5" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    refresh:
      '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6.5 9A6.5 6.5 0 0 1 18 6.2L19.5 8M17.5 15A6.5 6.5 0 0 1 6 17.8L4.5 16M19.5 4.5V8h-3.5M4.5 19.5V16H8" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    structure:
      '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M5 6.5h14M5 12h14M5 17.5h14" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/><path d="M5 6.5h.01M5 12h.01M5 17.5h.01" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"/></svg>',
  };

  customElements.define(
    'tro-training-program-recommender',
    class TROTrainingProgramRecommender extends HTMLElement {
      constructor() {
        super();

        this.answers = {};
        this.currentStep = 'path';
        this.onClick = this.onClick.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
      }

      connectedCallback() {
        this.config = this.readConfig();
        this.iconOverrides = this.buildIconOverrides(this.config.iconOverrides);
        this.form = this.querySelector('[data-recommender-form]');
        this.stepList = this.querySelector('[data-step-list]');
        this.progress = this.querySelector('[data-recommender-progress]');
        this.progressFill = this.querySelector('[data-progress-fill]');
        this.questionRegion = this.querySelector('[data-question-region]');
        this.resultRegion = this.querySelector('[data-result-region]');

        this.addEventListener('click', this.onClick);
        this.addEventListener('change', this.onChange);
        this.form?.addEventListener('submit', this.onSubmit);

        this.render();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('change', this.onChange);
        this.form?.removeEventListener('submit', this.onSubmit);
      }

      readConfig() {
        const script = this.querySelector('[data-recommender-config]');
        if (!script) return {};

        try {
          return JSON.parse(script.textContent);
        } catch (error) {
          console.error('Training program recommender config could not be parsed', error);
          return {};
        }
      }

      buildIconOverrides(overrides) {
        return (overrides || []).reduce((map, item) => {
          if (item?.key && item?.src) map[item.key] = item;
          return map;
        }, {});
      }

      onSubmit(event) {
        event.preventDefault();
      }

      onClick(event) {
        const stepButton = event.target.closest('[data-step-nav]');
        if (stepButton && this.contains(stepButton)) {
          const step = stepButton.dataset.stepKey;
          if (this.canNavigateToStep(step)) this.goToStep(step, true);
          return;
        }

        const backButton = event.target.closest('[data-recommender-back]');
        if (backButton && this.contains(backButton)) {
          const previousStep = stepKeys[Math.max(0, stepKeys.indexOf(this.currentStep) - 1)];
          this.goToStep(previousStep || 'path', true);
          return;
        }

        const restartButton = event.target.closest('[data-recommender-restart]');
        if (restartButton && this.contains(restartButton)) {
          this.answers = {};
          this.goToStep('path', true);
          return;
        }

        const clickedInput =
          event.target.closest('[data-answer-option]') ||
          event.target.closest('[data-answer-key]')?.querySelector('[data-answer-option]');

        if (clickedInput && this.contains(clickedInput)) {
          const stageKey = clickedInput.dataset.answerStage;
          if (clickedInput.checked && this.answers[stageKey] === clickedInput.value) {
            event.preventDefault();
            this.setAnswer(stageKey, clickedInput.value);
            this.advanceFromStage(stageKey, true);
          }
        }
      }

      onChange(event) {
        const input = event.target.closest('[data-answer-option]');
        if (!input || !this.contains(input)) return;

        this.setAnswer(input.dataset.answerStage, input.value);
        this.advanceFromStage(input.dataset.answerStage, true);
      }

      advanceFromStage(stageKey, focusAfterRender) {
        const nextStep = stepKeys[stepKeys.indexOf(stageKey) + 1] || 'result';
        this.goToStep(nextStep, focusAfterRender);
      }

      setAnswer(stageKey, value) {
        if (stageKey === 'path') {
          if (this.answers.path !== value) {
            this.answers = { path: value };
          } else {
            this.answers.path = value;
          }
          return;
        }

        if (stageKey === 'situation') {
          if (this.answers.situation !== value) {
            this.answers.situation = value;
            delete this.answers.priority;
          } else {
            this.answers.situation = value;
          }
          return;
        }

        if (stageKey === 'priority') {
          this.answers.priority = value;
        }
      }

      goToStep(step, focusAfterRender) {
        this.currentStep = this.canNavigateToStep(step) ? step : this.getHighestReachableStep();
        this.render();
        if (focusAfterRender) this.focusCurrentPanel();
      }

      render() {
        if (!this.canNavigateToStep(this.currentStep)) {
          this.currentStep = this.getHighestReachableStep();
        }

        this.updateDataset();
        this.renderStepButtons();
        this.updateProgress();

        if (this.currentStep === 'result') {
          this.renderResult();
        } else {
          this.renderQuestion();
        }
      }

      updateDataset() {
        this.dataset.currentStep = this.currentStep;
        this.dataset.stepCount = String(stepKeys.length);
        this.dataset.progress = String(this.getProgressValue());
        this.style.setProperty('--recommender-step-count', String(stepKeys.length));

        ['path', 'situation', 'priority'].forEach((key) => {
          const datasetKey = `answer${key.charAt(0).toUpperCase()}${key.slice(1)}`;
          if (this.answers[key]) this.dataset[datasetKey] = this.answers[key];
          else delete this.dataset[datasetKey];
        });
      }

      renderStepButtons() {
        if (!this.stepList) return;

        this.stepList.innerHTML = stepKeys
          .map((stepKey, index) => {
            const stepNumber = index + 1;
            const enabled = this.canNavigateToStep(stepKey);
            const current = stepKey === this.currentStep;
            const complete = this.isStepComplete(stepKey);
            const label = stepLabels[stepKey];

            return `
              <button
                type="button"
                class="training-program-recommender__step-button${complete ? ' is-complete' : ''}"
                data-step-nav
                data-step-key="${this.escapeAttribute(stepKey)}"
                data-step-index="${stepNumber}"
                data-step-state="${current ? 'current' : complete ? 'complete' : enabled ? 'available' : 'disabled'}"
                aria-label="${this.escapeAttribute(
                  `${stepNumber}. ${label}${current ? ', aktiivinen' : complete ? ', valmis' : !enabled ? ', ei vielä käytettävissä' : ''}`
                )}"
                aria-disabled="${String(!enabled)}"
                ${current ? 'aria-current="step"' : ''}
                ${enabled ? '' : 'disabled'}
              >
                <span class="training-program-recommender__step-number" aria-hidden="true">${stepNumber}</span>
                <span class="training-program-recommender__step-label">${this.escapeHtml(label)}</span>
              </button>
            `;
          })
          .join('');
      }

      updateProgress() {
        const progressValue = this.getProgressValue();
        if (this.progress) {
          this.progress.setAttribute('aria-valuenow', String(progressValue));
          this.progress.dataset.progressValue = String(progressValue);
        }

        if (this.progressFill) this.progressFill.style.width = `${progressValue}%`;
      }

      getProgressValue() {
        const activeIndex = Math.max(0, stepKeys.indexOf(this.currentStep));
        return (activeIndex + 1) * 25;
      }

      renderQuestion() {
        if (!this.questionRegion || !this.resultRegion) return;

        const question = this.getQuestion(this.currentStep);
        if (!question) {
          this.currentStep = this.getHighestReachableStep();
          this.render();
          return;
        }

        this.resultRegion.hidden = true;
        this.resultRegion.innerHTML = '';
        this.questionRegion.hidden = false;

        const questionId = this.getScopedId(`Question-${this.currentStep}`);
        const selectedValue = this.answers[this.currentStep];
        const name = this.getScopedId(`answer-${this.currentStep}`);
        const options = question.options
          .map((option) => this.renderOption(option, this.currentStep, name, selectedValue))
          .join('');
        const questionNumber = stepKeys.indexOf(this.currentStep) + 1;
        const showBack = this.currentStep !== 'path';

        this.questionRegion.innerHTML = `
          <div class="training-program-recommender__question" data-question-step="${this.escapeAttribute(
            this.currentStep
          )}">
            <div class="training-program-recommender__question-copy">
              <p class="training-program-recommender__question-kicker">Kysymys ${questionNumber} / 3</p>
              <h3 class="training-program-recommender__question-title h2" id="${questionId}" tabindex="-1">${this.escapeHtml(
          question.question
        )}</h3>
            </div>

            <fieldset class="training-program-recommender__fieldset" aria-labelledby="${questionId}">
              <legend class="visually-hidden">${this.escapeHtml(question.question)}</legend>
              <div class="training-program-recommender__options" data-answer-stage="${this.escapeAttribute(this.currentStep)}">
                ${options}
              </div>
            </fieldset>

            ${
              showBack
                ? `<div class="training-program-recommender__actions">
                    <button type="button" class="training-program-recommender__back button button--secondary" data-recommender-back>
                      Takaisin
                    </button>
                  </div>`
                : ''
            }
          </div>
        `;
      }

      renderOption(option, stageKey, name, selectedValue) {
        const id = this.getScopedId(`${stageKey}-${option.value}`);
        const checked = selectedValue === option.value ? ' checked' : '';
        const hasBadge = Boolean(option.badge);
        const badge = hasBadge
          ? `<span class="training-program-recommender__badge">${this.escapeHtml(option.badge)}</span>`
          : '';

        return `
          <label class="training-program-recommender__option" data-answer-key="${this.escapeAttribute(option.key)}">
            <input
              id="${id}"
              class="training-program-recommender__input"
              type="radio"
              name="${name}"
              value="${this.escapeAttribute(option.value)}"
              data-answer-option
              data-answer-stage="${this.escapeAttribute(stageKey)}"
              data-answer-key="${this.escapeAttribute(option.key)}"
              aria-describedby="${id}-label"
              ${checked}
            >
            <span class="training-program-recommender__option-card${hasBadge ? ' has-badge' : ''}">
              ${badge}
              ${this.renderIcon(option)}
              <span class="training-program-recommender__option-text" id="${id}-label">${this.escapeHtml(option.label)}</span>
              <span class="training-program-recommender__radio" aria-hidden="true"></span>
            </span>
          </label>
        `;
      }

      renderIcon(option) {
        const override = this.iconOverrides[option.key];

        if (override?.src) {
          return `
            <span class="training-program-recommender__icon" aria-hidden="true">
              <img src="${this.escapeAttribute(override.src)}" alt="" width="44" height="44" loading="lazy">
            </span>
          `;
        }

        const mappedIcon = optionIconMap[option.value];
        if (mappedIcon?.iconUrl) {
          return `
            <span class="training-program-recommender__icon" aria-hidden="true">
              <img src="${this.escapeAttribute(mappedIcon.iconUrl)}" alt="" width="44" height="44" loading="lazy">
            </span>
          `;
        }

        if (mappedIcon?.starsPattern) {
          return this.renderStarIcon(mappedIcon.starsPattern);
        }

        return `
          <span class="training-program-recommender__icon" aria-hidden="true">
            ${defaultIcons[option.icon] || defaultIcons.check}
          </span>
        `;
      }

      renderStarIcon(pattern) {
        const stars = pattern
          .map((state) => {
            const filled = state === 'filled';
            return `
              <span class="training-program-recommender__star${filled ? ' is-filled' : ' is-empty'}">
                <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                  <path d="M12 3.2l2.6 5.3 5.9.9-4.2 4.1 1 5.8-5.3-2.8-5.3 2.8 1-5.8-4.2-4.1 5.9-.9L12 3.2z"></path>
                </svg>
              </span>
            `;
          })
          .join('');

        return `
          <span class="training-program-recommender__icon training-program-recommender__icon--stars" aria-hidden="true">
            <span class="training-program-recommender__stars">${stars}</span>
          </span>
        `;
      }

      renderResult() {
        if (!this.questionRegion || !this.resultRegion) return;

        const productKey = this.resolveProductKey();
        const personalization = this.resolvePersonalization(productKey);
        const product = this.config.products?.[productKey] || {};
        const title = product.title || productKey;
        const image = product.image
          ? `<img src="${this.escapeAttribute(product.image)}" alt="${this.escapeAttribute(product.imageAlt || title)}" width="560" height="560" loading="lazy">`
          : `<span class="training-program-recommender__placeholder" aria-hidden="true">${defaultIcons.barbell}</span>`;
        const url = product.url || '#';
        const note = personalization.optionalResultNote
          ? `<p class="training-program-recommender__result-note">${this.escapeHtml(personalization.optionalResultNote)}</p>`
          : '';

        this.dataset.resultProduct = productKey;
        this.questionRegion.hidden = true;
        this.questionRegion.innerHTML = '';
        this.resultRegion.hidden = false;
        this.resultRegion.innerHTML = `
          <div class="training-program-recommender__result" data-result-type="product" data-result-product="${this.escapeAttribute(
            productKey
          )}">
            <div class="training-program-recommender__result-card">
              <div class="training-program-recommender__result-media">
                ${image}
              </div>
              <div class="training-program-recommender__result-content">
                <div class="training-program-recommender__result-badges">
                  <span class="training-program-recommender__result-label">Suositus</span>
                  <span class="training-program-recommender__result-badge">${this.escapeHtml(personalization.resultBadge)}</span>
                </div>
                <h3 class="training-program-recommender__result-title h2" tabindex="-1">${this.escapeHtml(title)}</h3>
                ${note}
                <div class="training-program-recommender__result-actions">
                  <a class="button button--primary" href="${this.escapeAttribute(url)}">Tutustu ohjelmaan</a>
                  <button type="button" class="training-program-recommender__restart button button--secondary" data-recommender-restart>
                    Aloita alusta
                  </button>
                </div>
              </div>
            </div>
          </div>
        `;
      }

      resolveProductKey() {
        const rule = resultRules[this.answers.path];
        if (typeof rule === 'string') return rule;
        return rule?.[this.answers.situation] || 'rookie_program';
      }

      resolvePersonalization(productKey) {
        const resolver = personalizationRules[this.answers.path];
        const personalization = typeof resolver === 'function' ? resolver({ ...this.answers, productKey }) : null;
        return {
          ...defaultPersonalization,
          ...personalization,
        };
      }

      getQuestion(stepKey) {
        if (stepKey === 'path') return questionConfig.path;
        if (stepKey === 'situation') return questionConfig.situation[this.answers.path] || null;
        if (stepKey === 'priority') return questionConfig.priority[this.answers.path] || null;
        return null;
      }

      getHighestReachableStep() {
        if (!this.answers.path) return 'path';
        if (!this.answers.situation) return 'situation';
        if (!this.answers.priority) return 'priority';
        return 'result';
      }

      canNavigateToStep(stepKey) {
        if (!stepKeys.includes(stepKey)) return false;
        if (stepKey === 'path') return true;
        if (stepKey === 'situation') return Boolean(this.answers.path);
        if (stepKey === 'priority') return Boolean(this.answers.path && this.answers.situation);
        if (stepKey === 'result') return Boolean(this.answers.path && this.answers.situation && this.answers.priority);
        return false;
      }

      isStepComplete(stepKey) {
        if (stepKey === 'path') return Boolean(this.answers.path);
        if (stepKey === 'situation') return Boolean(this.answers.situation);
        if (stepKey === 'priority') return Boolean(this.answers.priority);
        if (stepKey === 'result') return this.canNavigateToStep('result');
        return false;
      }

      getScopedId(value) {
        const sectionId = this.dataset.sectionId || this.id || 'tro';
        return `${sectionId}-${value}`.replace(/[^a-zA-Z0-9_-]/g, '-');
      }

      focusCurrentPanel() {
        window.requestAnimationFrame(() => {
          const heading =
            this.currentStep === 'result'
              ? this.resultRegion?.querySelector('.training-program-recommender__result-title')
              : this.questionRegion?.querySelector('.training-program-recommender__question-title');

          heading?.focus({ preventScroll: true });
        });
      }

      escapeHtml(value) {
        return String(value ?? '')
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#039;');
      }

      escapeAttribute(value) {
        return this.escapeHtml(value);
      }
    }
  );
})();
